/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigLeftDash = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M19 15V9" }],
    ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z" }]
  ]
];

export { ArrowBigLeftDash as default };
//# sourceMappingURL=arrow-big-left-dash.js.map
